var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarNotFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9986 0C10.3472 0 10.6654 0.205116 10.817 0.528222L13.4161 6.04798L19.2243 6.93486C19.5653 6.98566 19.8456 7.23179 19.9555 7.56779C20.0616 7.9077 19.9744 8.27886 19.732 8.525L15.5188 12.8305L16.5153 18.9058C16.5721 19.2574 16.4319 19.6169 16.1478 19.8239C15.8674 20.031 15.462 20.0584 15.1892 19.8904L9.9986 17.0305L4.77766 19.8904C4.50487 20.0584 4.13357 20.031 3.84941 19.8239C3.56904 19.6169 3.42886 19.2574 3.45159 18.9058L4.47835 12.8305L0.269396 8.525C0.0246413 8.27886 -0.0621217 7.9077 0.0454796 7.56779C0.152702 7.23179 0.435724 6.98566 0.776335 6.93486L6.58112 6.04798L9.18022 0.528222C9.33556 0.205077 9.65003 0 9.9986 0ZM9.9986 3.08455L8.00949 7.31384C7.87688 7.59123 7.61924 7.78658 7.32372 7.83347L2.84084 8.51328L6.09616 11.8381C6.30454 12.053 6.39926 12.3616 6.35 12.6625L5.58467 17.3352L9.57047 15.1395C9.83947 14.991 10.1615 14.991 10.4267 15.1395L14.4125 17.3352L13.6472 12.6625C13.5979 12.3616 13.6964 12.053 13.9048 11.8381L17.1594 8.51328L12.6773 7.83347C12.3779 7.78658 12.1203 7.59123 11.9915 7.31384L9.9986 3.08455Z",
    fill: "#CB8D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarNotFill);
export default __webpack_public_path__ + "static/media/star-not-fill.2789a79d746a88716c80167fd1c660a6.svg";
export { ForwardRef as ReactComponent };